module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    attrs: {
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('groupSettlement.groupSettlementRegister')
    }
  })], 1), _vm._v(" "), _c('form', {
    ref: "registerGroupSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.validateAndSubmit($event)
      }
    }
  }, [_c('b-card', {
    staticClass: "mb-2"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('groupSettlement.groupSettlementNumber')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.groupSettlement.groupSettlementNumber.$error
    },
    attrs: {
      "name": "groupSettlement.groupSettlementNumber"
    },
    model: {
      value: (_vm.groupSettlement.groupSettlementNumber),
      callback: function($$v) {
        _vm.$set(_vm.groupSettlement, "groupSettlementNumber", $$v)
      },
      expression: "groupSettlement.groupSettlementNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": ""
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('groupSettlement.massInput')
    }
  }, [_c('b-form-textarea', {
    staticClass: "monospace-input",
    class: {
      'error': _vm.$v.massInput.$error
    },
    attrs: {
      "rows": 15,
      "max-rows": 32
    },
    model: {
      value: (_vm.massInput),
      callback: function($$v) {
        _vm.massInput = $$v
      },
      expression: "massInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "danger",
      "header": _vm.$t('groupSettlement.massInputError.tableHeader'),
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.errorList), function(error) {
    return _c('b-list-group-item', {
      key: error
    }, [_vm._v(_vm._s(error))])
  }), 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.registerSingleConfirmationModal",
      modifiers: {
        "registerSingleConfirmationModal": true
      }
    }],
    attrs: {
      "variant": "primary",
      "disabled": _vm.load
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('groupSettlement.groupSettlementSubmit')) + "\n                    "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    attrs: {
      "id": "registerSingleConfirmationModal",
      "ok-title": _vm.$t('forms.submit'),
      "cancel-title": _vm.$t('forms.cancel')
    },
    on: {
      "ok": _vm.validateAndSubmit
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('groupSettlement.groupSettlementConfirmation')) + "\n            ")])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62de2e97", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62de2e97","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/group-settlement/register-group-settlement/RegisterGroupSettlement.vue
// module id = 788
// module chunks = 1